export default __webpack_public_path__ + "static/media/mPants_1_c3.d5e7b815.jpeg";